import { Col, Space } from 'antd'
import { FC } from 'react'

import { BitazzaText } from '../../../../components'
import { format } from '../../../../components/common/Typography/Text'

interface Props {
    img: string
    total: string | number | null
    product?: string
    reward?: string
    textFormat?: format
    textColor?: string
    nft_type?: string
    bigSize?: boolean
}
export const Reward: FC<Props> = ({
    img,
    total,
    product,
    reward,
    textFormat,
    textColor,
    nft_type,
    bigSize,
}) => {
    return (
        <Col span={12}>
            <Space direction="vertical" size={0}>
                <img
                    src={img}
                    alt="rewards"
                    width={bigSize ? 78 : 48}
                    style={{ paddingBottom: '8px' }}
                />
                {total ? (
                    <BitazzaText
                        content={total}
                        color={textColor ? textColor : '#10F48B'}
                        format={textFormat ? textFormat : 't20'}
                        lineHeight={26}
                        strong
                    />
                ) : null}

                {nft_type ? (
                    <BitazzaText
                        content={nft_type}
                        format="t20"
                        bold
                        color="#FFFFFF"
                        textAlign="center"
                    />
                ) : null}

                {product ?? (
                    <BitazzaText
                        content={product}
                        color="#FFFF"
                        letterSpacing={1}
                    />
                )}
                <BitazzaText content={reward || ''} color="#86A1A1" />
            </Space>
        </Col>
    )
}
